import { Card, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleBar from 'simplebar-react';
import { dateFormat, useJobs } from 'src/hooks';
import useStyles from './styles';

export const JobsHistory: ComponentType<{ pin?: string | number }> = ({ pin }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { history, handleGetJobsHistory } = useJobs();

  const _data = history?.data
    ? [...history.data].sort(
        (objA: any, objB: any) =>
          new Date(objB.start_date).getTime() - new Date(objA.start_date).getTime()
      )
    : [];

  useEffect(() => {
    if (pin) {
      handleGetJobsHistory(pin);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pin]);

  // const isCurrentJob = (item: Record<string, any>) => !item.hasOwnProperty('end_date');

  return (
    <Card sx={{ p: 3, border: 0 }} className={classes.root}>
      <Typography variant="h3" mb={3}>
        {t('jobs.historyBook', 'Трудовая книжка')}
      </Typography>
      <SimpleBar className={classes.container}>
        <Table size="small" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell component="th">№</TableCell>
              <TableCell component="th">{t('jobs.startDate', 'Дата начала работы')}</TableCell>
              {/* <TableCell component="th">{t('jobs.endDate', 'Дата окончания работы')}</TableCell> */}
              <TableCell component="th">{t('jobs.companyName', 'Организация')}</TableCell>
              <TableCell component="th">{t('profile.tin', 'ИНН')}</TableCell>
              <TableCell component="th">{t('jobs.positionName', 'Должность')}</TableCell>
              {/* <TableCell component="th">{t('profile.department', 'Отдел')}</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {map(
              _data,
              // .sort(
              //   (a: Record<string, any>, b: Record<string, any>) =>
              //     Number(new Date(b.start_date)) - Number(new Date(a.start_date))
              // ),
              (item: Record<string, any>, index: number) => (
                <TableRow key={index} sx={{ '&:last-child td': { border: 0 } }}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {/* {isCurrentJob(item) ? dateFormat(item.beginDate) : dateFormat(item.start_date)} */}
                    {dateFormat(item.start_date)}
                  </TableCell>
                  {/* <TableCell>
                  {item.end_date ? dateFormat(item.end_date) : t('jobs.untilNow', 'До сих пор')}
                </TableCell> */}
                  <TableCell>{item.company_name}</TableCell>
                  <TableCell>{item.company_inn}</TableCell>
                  <TableCell>{item.position_name}</TableCell>
                  {/* <TableCell>{item.structure_name}</TableCell> */}
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </SimpleBar>
    </Card>
  );
};
